<mat-accordion class="example-headers-align" multi>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span mat-line
          >Invoice
          <mat-icon aria-hidden="false" aria-label="Example home icon"
            >picture_as_pdf</mat-icon
          ></span
        >
      </mat-panel-title>
    </mat-expansion-panel-header>
    <span class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" (click)="OpenDialogMasivo('Invoice')">
      Download
      <mat-icon aria-hidden="false" aria-label="file_download"
        >file_download</mat-icon
      >
    </span>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span mat-line
          >Receive Summary
          <mat-icon aria-hidden="false" aria-label="Example home icon"
            >picture_as_pdf</mat-icon
          ></span
        >
      </mat-panel-title>
    </mat-expansion-panel-header>
    <span class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" (click)="OpenDialogMasivo('Receive_Summary')">
      Download
      <mat-icon aria-hidden="false" aria-label="file_download"
        >file_download</mat-icon
      >
    </span>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span mat-line
          >Labels<mat-icon aria-hidden="false" aria-label="Example home icon"
            >picture_as_pdf</mat-icon
          ></span
        >
      </mat-panel-title>
    </mat-expansion-panel-header>

    <span class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" (click)="OpenDialogMasivo('Labels')">
      Download
      <mat-icon aria-hidden="false" aria-label="file_download"
        >file_download</mat-icon
      >
    </span>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span mat-line
          >Pallet Labels<mat-icon
            aria-hidden="false"
            aria-label="Example home icon"
            >picture_as_pdf</mat-icon
          ></span
        >
      </mat-panel-title>
    </mat-expansion-panel-header>
    <span class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" (click)="OpenDialogMasivo('Pallet_Labels')">
      Download
      <mat-icon aria-hidden="false" aria-label="file_download"
        >file_download</mat-icon
      >
    </span>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span mat-line
          >Discrepancy Report<mat-icon
            aria-hidden="false"
            aria-label="Example home icon"
            >picture_as_pdf</mat-icon
          ></span
        >
      </mat-panel-title>
    </mat-expansion-panel-header>
    <span class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" (click)="OpenDialogMasivo('Discrepancy_Report')">
      Download
      <mat-icon aria-hidden="false" aria-label="file_download"
        >file_download</mat-icon
      >
    </span>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span mat-line
          >Receiving by Pallets<mat-icon
            aria-hidden="false"
            aria-label="Example home icon"
            >picture_as_pdf</mat-icon
          ></span
        >
      </mat-panel-title>
    </mat-expansion-panel-header>
    <span class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" (click)="OpenDialogMasivo('Receiving_by_Pallets')">
      Download
      <mat-icon aria-hidden="false" aria-label="file_download"
        >file_download</mat-icon
      >
    </span>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span mat-line
          >Receiving by Pallets Carton<mat-icon
            aria-hidden="false"
            aria-label="Example home icon"
            >picture_as_pdf</mat-icon
          ></span
        >
      </mat-panel-title>
    </mat-expansion-panel-header>
    <span
      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
      (click)="OpenDialogMasivo('Receiving_by_Pallets_Carton')"
    >
      Download
      <mat-icon aria-hidden="false" aria-label="file_download"
        >file_download</mat-icon
      >
    </span>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span mat-line
          >Page Pallet Label<mat-icon
            aria-hidden="false"
            aria-label="Example home icon"
            >picture_as_pdf</mat-icon
          ></span
        >
      </mat-panel-title>
    </mat-expansion-panel-header>
    <span class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" (click)="OpenDialogMasivo('Page_Pallet_Label')">
      Download
      <mat-icon aria-hidden="false" aria-label="file_download"
        >file_download</mat-icon
      >
    </span>
  </mat-expansion-panel>
  <mat-expansion-panel *ngIf="isLdt">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span mat-line
          >Page Pallet Label kemflo<mat-icon
            aria-hidden="false"
            aria-label="Example home icon"
            >picture_as_pdf</mat-icon
          ></span
        >
      </mat-panel-title>
    </mat-expansion-panel-header>
    <span class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" (click)="OpenDialogMasivo('Page_Pallet_Label_kem')">
      Download
      <mat-icon aria-hidden="false" aria-label="file_download"
        >file_download</mat-icon
      >
    </span>
  </mat-expansion-panel>

  <mat-expansion-panel *ngIf="isLdt">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span mat-line
          >Page Pallet Group<mat-icon
            aria-hidden="false"
            aria-label="Example home icon"
            >picture_as_pdf</mat-icon
          ></span
        >
      </mat-panel-title>
    </mat-expansion-panel-header>
    <span class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" (click)="OpenDialogMasivo('Page_Pallet_Group')">
      Download
      <mat-icon aria-hidden="false" aria-label="file_download"
        >file_download</mat-icon
      >
    </span>
  </mat-expansion-panel>
</mat-accordion>
